/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Sort_Sortarialabel2Inputs */

const id_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urutkan penawaran`)
};

const ms_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susun tawaran`)
};

const da_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorter tilbud`)
};

const de_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebote sortieren`)
};

const en_us2_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort offers`)
};

const es_es2_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar resultados`)
};

const es_mx2_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar ofertas`)
};

const fil_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagbukud-bukurin ang mga offer`)
};

const fr_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trier les offres`)
};

const it_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordina offerte`)
};

const hu_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajánlatok rendezése`)
};

const nl_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanbiedingen sorteren`)
};

const no_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorter tilbud`)
};

const pl_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortuj oferty`)
};

const pt_br2_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar resultados`)
};

const pt_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar ofertas`)
};

const ro_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortează ofertele`)
};

const fi_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Järjestä tarjoukset`)
};

const sv_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortera erbjudanden`)
};

const vi_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp xếp ưu đãi`)
};

const tr_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklifleri sırala`)
};

const cs_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seřadit nabídky`)
};

const bg_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортиране на оферти`)
};

const ru_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортировать предложения`)
};

const uk_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортувати пропозиції`)
};

const ar_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ترتيب العروض`)
};

const hi_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़र क्रमबद्ध करें`)
};

const th_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จัดเรียงข้อเสนอ`)
};

const ja_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オファーを並び替え`)
};

const zh_cn2_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排序目录项`)
};

const zh_hant1_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排序目錄項目`)
};

const ko_search_sort_sortarialabel2 = /** @type {(inputs: Search_Sort_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오퍼 정렬`)
};

/**
* | output |
* | --- |
* | "Sort offers" |
*
* @param {Search_Sort_Sortarialabel2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_sort_sortarialabel2 = /** @type {((inputs?: Search_Sort_Sortarialabel2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Sort_Sortarialabel2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_sort_sortarialabel2(inputs)
	if (locale === "ms") return ms_search_sort_sortarialabel2(inputs)
	if (locale === "da") return da_search_sort_sortarialabel2(inputs)
	if (locale === "de") return de_search_sort_sortarialabel2(inputs)
	if (locale === "en-US") return en_us2_search_sort_sortarialabel2(inputs)
	if (locale === "es-ES") return es_es2_search_sort_sortarialabel2(inputs)
	if (locale === "es-MX") return es_mx2_search_sort_sortarialabel2(inputs)
	if (locale === "fil") return fil_search_sort_sortarialabel2(inputs)
	if (locale === "fr") return fr_search_sort_sortarialabel2(inputs)
	if (locale === "it") return it_search_sort_sortarialabel2(inputs)
	if (locale === "hu") return hu_search_sort_sortarialabel2(inputs)
	if (locale === "nl") return nl_search_sort_sortarialabel2(inputs)
	if (locale === "no") return no_search_sort_sortarialabel2(inputs)
	if (locale === "pl") return pl_search_sort_sortarialabel2(inputs)
	if (locale === "pt-BR") return pt_br2_search_sort_sortarialabel2(inputs)
	if (locale === "pt") return pt_search_sort_sortarialabel2(inputs)
	if (locale === "ro") return ro_search_sort_sortarialabel2(inputs)
	if (locale === "fi") return fi_search_sort_sortarialabel2(inputs)
	if (locale === "sv") return sv_search_sort_sortarialabel2(inputs)
	if (locale === "vi") return vi_search_sort_sortarialabel2(inputs)
	if (locale === "tr") return tr_search_sort_sortarialabel2(inputs)
	if (locale === "cs") return cs_search_sort_sortarialabel2(inputs)
	if (locale === "bg") return bg_search_sort_sortarialabel2(inputs)
	if (locale === "ru") return ru_search_sort_sortarialabel2(inputs)
	if (locale === "uk") return uk_search_sort_sortarialabel2(inputs)
	if (locale === "ar") return ar_search_sort_sortarialabel2(inputs)
	if (locale === "hi") return hi_search_sort_sortarialabel2(inputs)
	if (locale === "th") return th_search_sort_sortarialabel2(inputs)
	if (locale === "ja") return ja_search_sort_sortarialabel2(inputs)
	if (locale === "zh-CN") return zh_cn2_search_sort_sortarialabel2(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_sort_sortarialabel2(inputs)
	return ko_search_sort_sortarialabel2(inputs)
});
export { search_sort_sortarialabel2 as "search.sort.sortAriaLabel" }